/* eslint-disable import/default */
import React from 'react';
import { render } from 'react-dom';
import Main from './src/Main';
// import injectTapEventPlugin from 'react-tap-event-plugin';
import 'reset-css';
// require('./static/favicon.ico');
import './src/styles.scss';
import 'font-awesome/css/font-awesome.css';
import 'flexboxgrid/css/flexboxgrid.css';

// try {  // DEPRECATED READ HERE https://www.npmjs.com/package/react-tap-event-plugin Since the problem it solves has been fixed in most browsers by now you should migrate away from this plugin.
//   injectTapEventPlugin();
// }
// catch(e) {
//   console.warn( e );
// }

render(
  <Main/>, document.getElementById('app')
);



// WEBPACK FOOTER //
// ./entry.js